import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import Header from '../components/Header';
import { loginRequest, receiveMessage, windowResize } from '../utils';

class ClientRoute extends Component {
	componentDidMount = async () => {
		window.addEventListener("message", receiveMessage, false);
		loginRequest();
		for(let i=0;i<10;i++){
			document.getElementById("first-loader").style.display = "none";
			setTimeout(() => {
				windowResize();
			}, 1000);
		}
	}

	render() {
		const { component: Component, ...rest } = this.props;
		return (
			<Route
				{...rest}
				render={props => (
					<main id="page-wrap">
						<Row className="no-gutters">
							{/* <Col md="2" className="d-none d-md-block">
								<img src="/assets/banners/BW_SA_Jackpots_DesktopLeftPanel.jpg" className="w-100" />
							</Col> */}
							<Col className="px-0 px-md-2" md="12">
								<Header  jackpot={{ name: "multi-market", link: "/" }} />
								<Component {...props} />
							</Col>
							{/* <Col md="2" className="d-none d-md-block">
								<img src="/assets/banners/BW_SA_Jackpots_DesktopRightPanel.jpg" className="w-100" />
							</Col> */}
						</Row>
					</main>
				)}
			/>
		);
	}
}

export default ClientRoute;



// WEBPACK FOOTER //
// ./routes/ClientRoute.js